module.exports = __webpack_public_path__ + "static/media/bell.af1f6414.gif";